import { render, staticRenderFns } from "./JournalEntryQuestion.vue?vue&type=template&id=5b7fe010"
import script from "./JournalEntryQuestion.vue?vue&type=script&lang=js"
export * from "./JournalEntryQuestion.vue?vue&type=script&lang=js"
import style0 from "./JournalEntryQuestion.vue?vue&type=style&index=0&id=5b7fe010&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports